// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import { createSelector } from '@atlassian/react-sweet-state';
import type { State } from '../types.tsx';

export const isIssueSelected = createSelector(
	(state: State) => ({
		selectedIssues: state.selectedIssues,
		fetchingGroups: state.fetchingGroups,
	}),
	(__, { issueId, parentIssueId }: { issueId: string; parentIssueId?: string }) => ({
		issueId,
		parentIssueId,
	}),
	({ selectedIssues, fetchingGroups }, issue) => {
		if (selectedIssues.has(String(issue.issueId))) return true;
		if (issue.parentIssueId) {
			// Optimistic selection
			return fetchingGroups.includes(String(issue.parentIssueId));
		}
		return false;
	},
);

export const isGroupSelected = createSelector(
	(state: State) => state.selectedGroups,
	(__, groupId: string | undefined) => groupId,
	(selectedGroups, groupId) => {
		if (!groupId) return false;
		return selectedGroups.has(groupId);
	},
);

export const diffIssuesSelected = createSelector(
	(state: State) => state.selectedIssues,
	(__, issues: string[] | undefined) => issues,
	(selectedIssues, issues) => {
		if (!issues) return undefined;
		const diff: string[] = [];
		issues.forEach((issueId) => {
			if (!selectedIssues.has(issueId)) {
				diff.push(issueId);
			}
		});
		return diff;
	},
);
